import {actionCreator} from "../../core/store/common/actionCreator";

export class TooltipsAction {
    public static showTooltips = actionCreator<string>("Tooltips/SHOW");
    public static closeTooltips = actionCreator<IEmpty>("Tooltips/CLEAR");
}
